export const DELETED = '@attribute/DELETED' as const;
export type DeletedAttribute = typeof DELETED;
